import React, { useState } from 'react';
import { supabase } from '../config/supabaseClient';
import styles from '../pages/Contacts.module.css';

const VendorModal = ({ vendor, closeModal, onSuccess }) => {
  const [formData, setFormData] = useState(
    vendor || {
      vendor_code: '',
      name: '',
      abbr_name: '',
      vendor_type: '',
      pay_term: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      tel1: '',
      tel2: '',
      fax: '',
      contact_person: '',
      email: '',
      active_yn: true
    }
  );
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      if (vendor) {
        // Update existing vendor
        const { error } = await supabase
          .from('vendors')
          .update(formData)
          .eq('id', vendor.id);

        if (error) throw error;
        setSuccess('Vendor updated successfully');
      } else {
        // Add new vendor
        const { error } = await supabase
          .from('vendors')
          .insert([formData]);

        if (error) throw error;
        setSuccess('Vendor added successfully');
      }

      setTimeout(() => {
        onSuccess();
      }, 1500);
    } catch (error) {
      console.error('Error saving vendor:', error);
      setError(error.message);
    }
  };

  return (
    <div className={styles.modal} onClick={closeModal}>
      <div
        className={styles.modalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <h2 className={styles.sectionTitle}>
            {vendor ? 'Edit Vendor' : 'Add Vendor'}
          </h2>
          <button className={styles.closeButton} onClick={closeModal}>
            ×
          </button>
        </div>
        {error && <div className={styles.error}>{error}</div>}
        {success && <div className={styles.success}>{success}</div>}
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.formGrid}>
            <div className={styles.formField}>
              <label>Vendor Code</label>
              <input
                type="text"
                value={formData.vendor_code}
                onChange={(e) =>
                  setFormData({ ...formData, vendor_code: e.target.value })
                }
                required
              />
            </div>
            <div className={styles.formField}>
              <label>Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                required
              />
            </div>
            <div className={styles.formField}>
              <label>Abbreviated Name</label>
              <input
                type="text"
                value={formData.abbr_name}
                onChange={(e) =>
                  setFormData({ ...formData, abbr_name: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Vendor Type</label>
              <input
                type="text"
                value={formData.vendor_type}
                onChange={(e) =>
                  setFormData({ ...formData, vendor_type: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Payment Terms</label>
              <input
                type="text"
                value={formData.pay_term}
                onChange={(e) =>
                  setFormData({ ...formData, pay_term: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Street</label>
              <input
                type="text"
                value={formData.street}
                onChange={(e) =>
                  setFormData({ ...formData, street: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>City</label>
              <input
                type="text"
                value={formData.city}
                onChange={(e) =>
                  setFormData({ ...formData, city: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>State</label>
              <input
                type="text"
                value={formData.state}
                onChange={(e) =>
                  setFormData({ ...formData, state: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>ZIP</label>
              <input
                type="text"
                value={formData.zip}
                onChange={(e) =>
                  setFormData({ ...formData, zip: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Country</label>
              <input
                type="text"
                value={formData.country}
                onChange={(e) =>
                  setFormData({ ...formData, country: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Primary Phone</label>
              <input
                type="text"
                value={formData.tel1}
                onChange={(e) =>
                  setFormData({ ...formData, tel1: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Secondary Phone</label>
              <input
                type="text"
                value={formData.tel2}
                onChange={(e) =>
                  setFormData({ ...formData, tel2: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Fax</label>
              <input
                type="text"
                value={formData.fax}
                onChange={(e) =>
                  setFormData({ ...formData, fax: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Contact Person</label>
              <input
                type="text"
                value={formData.contact_person}
                onChange={(e) =>
                  setFormData({ ...formData, contact_person: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
            </div>
            <div className={styles.formField}>
              <label>Active</label>
              <select
                value={formData.active_yn}
                onChange={(e) =>
                  setFormData({ ...formData, active_yn: e.target.value === 'true' })
                }
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>
          <button type="submit" className={styles.submitButton}>
            {vendor ? 'Update Vendor' : 'Add Vendor'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VendorModal;
